
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    Compatibility: () => import("@/components/Compatibility.vue"),
    Postulate: () => import("@/components/postulation/Postulate.vue"),
    PostulationQuick: () =>
      import("@/components/postulation/PostulationQuick.vue"),
    AreYouSure: () => import("@/components/postulation/AreYouSure.vue"),
    SuccessfulPostulation: () =>
      import("@/components/postulation/SuccessfulPostulation.vue")
  }
})
export default class OfferInfo extends Vue {
  @Prop(Object) private offer!: any;
  @Prop(Number) index!: number;
  @Prop(Function) toggleOffer!: Object;
  @Prop(Boolean) withIdOffer!: boolean;
  isLogged = false;
  shareModal = false;
  link_social = "";

  mounted() {
    this.link_social = window.location.origin;
  }

  decode(text: string) {
    return text
      .replace(/(?:\r\n|\r|\n)/g, "<br>")
      .replace(/\\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
  }

  openModal(offer: any) {
    if ((this as any).$store.state.token) {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "Postulate";
        }
      );
      postulateComponent.offerId = offer.id;
      postulateComponent.showModal();
    } else {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "PostulationQuick";
        }
      );
      postulateComponent.offerId = offer.id;
      postulateComponent.showModal();
    }
  }

  openSuccessful() {
    (this as any).$children
      .find((children: any) => {
        return children.$options._componentTag === "SuccessfulPostulation";
      })
      .showModal();
  }

  openAreyousure() {
    (this as any).$children
      .find((children: any) => {
        return children.$options._componentTag === "AreYouSure";
      })
      .showModal();
  }
}
